// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/DashboardKPIBar.js
//
// Purpose:
// Service CRM Dashboard KPI Cards
//
// Approved KPIs:
//
// Total SRs
// Open SRs
// Assigned
// Resolved
// Closed
// Escalated
//
// Clickable
// Opens DashboardDataDrawer
// ======================================================================

import React from "react";

export default function DashboardKPIBar({

  kpis = {},

  onKpiClick,

}) {

  // ==========================================================
  // KPI CONFIG
  // ==========================================================

  const cards = [

    {
      key: "total",

      title: "Total SRs",

      value:
        kpis.total || 0,

      gradient:
        "linear-gradient(135deg,#0f172a,#1e40af)",
    },

    {
      key: "open",

      title: "Open SRs",

      value:
        kpis.open || 0,

      gradient:
        "linear-gradient(135deg,#dc2626,#ef4444)",
    },

    {
      key: "assigned",

      title: "Assigned",

      value:
        kpis.assigned || 0,

      gradient:
        "linear-gradient(135deg,#ea580c,#f97316)",
    },

    {
      key: "resolved",

      title: "Resolved",

      value:
        kpis.resolved || 0,

      gradient:
        "linear-gradient(135deg,#059669,#10b981)",
    },

    {
      key: "closed",

      title: "Closed",

      value:
        kpis.closed || 0,

      gradient:
        "linear-gradient(135deg,#374151,#111827)",
    },

    {
      key: "escalated",

      title: "Escalated",

      value:
        kpis.escalated || 0,

      gradient:
        "linear-gradient(135deg,#7c3aed,#9333ea)",
    },

  ];

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div
      style={{

        display: "grid",

        gridTemplateColumns:
          "repeat(auto-fit, minmax(220px, 1fr))",

        gap: 16,

        marginBottom: 20,
      }}
    >

      {cards.map((card) => (

        <div

          key={card.key}

          onClick={() =>
            onKpiClick &&
            onKpiClick(card.key)
          }

          style={{

            background:
              card.gradient,

            borderRadius: 16,

            padding: 20,

            color: "#fff",

            cursor: "pointer",

            transition:
              "all 0.25s ease",

            boxShadow:
              "0 6px 16px rgba(0,0,0,0.15)",

            minHeight: 120,

            display: "flex",

            flexDirection: "column",

            justifyContent: "space-between",
          }}

          onMouseEnter={(e) => {

            e.currentTarget.style.transform =
              "translateY(-4px)";
          }}

          onMouseLeave={(e) => {

            e.currentTarget.style.transform =
              "translateY(0px)";
          }}
        >

          <div
            style={{
              fontSize: 14,

              opacity: 0.95,

              fontWeight: 600,
            }}
          >
            {card.title}
          </div>

          <div
            style={{
              fontSize: 34,

              fontWeight: 800,

              lineHeight: 1,
            }}
          >
            {card.value}
          </div>

        </div>

      ))}

    </div>
  );
}